import * as React from 'react'

import { styled } from '~/styled'

export const StyledLi = styled('li', {
  base: ['last:mb-0', 'not-last:mb-2']
})

export const StyledList = styled('ul', {
  base: ['list-inside', 'font-body'],
  variants: {
    size: {
      xs: ['text-xs', 'leading-[1.6]', 'capsize-[0.4364]'],
      sm: ['text-sm', 'leading-[1.53]', 'capsize-[0.4056]'],
      md: ['text-md', 'leading-normal', 'capsize-[0.3864]'],
      lg: ['text-lg', 'leading-[1.52]', 'capsize-[0.3983]'],
      xl: ['text-xl', 'leading-[1.42]', 'capsize-[0.3506]']
    },
    noCapsize: {
      true: ['capsize-none']
    },
    ordered: {
      true: [
        'pl-4',
        'list-decimal',
        '[&_>_li]:pl-1',
        '[&_>_li::marker]:font-medium',
        '[&_>_li::marker]:text-sm'
      ],
      false: ['pl-3', 'list-disc', '[&_>_li]:pl-2']
    },
    theme: {
      primary: ['marker:text-primary-800']
    }
  }
})

type ListProps = React.ComponentProps<typeof StyledList> & {
  ordered?: boolean
}

type ListType = ReturnType<
  typeof React.forwardRef<HTMLUListElement, ListProps>
> & {
  Item: typeof StyledLi
}

export const List = React.forwardRef<HTMLUListElement, ListProps>(
  (
    { size = 'md', noCapsize = true, ordered = false, ...remainingProps },
    ref
  ) => (
    <StyledList
      ref={ref}
      as={ordered ? 'ol' : 'ul'}
      ordered={ordered}
      size={size}
      noCapsize={noCapsize}
      {...remainingProps}
    />
  )
) as ListType

List.Item = StyledLi
